import React from 'react';
import { HowlerPlayer } from './HowlerPlayer';


export let player = new HowlerPlayer();

export const PlayerContext = React.createContext(player);


